import { localeDateFromUTC, localeDateToUTC } from '@/helpers/timeHelper';

// This class is used to identify Payload objects
export class DtoExt {

  // Rip of yann's function to not assign undefined
  // CAREFULL : keys with? are not in Object.keys()
  public static assignToThis(target: DtoExt, options: any): void {
    Object.keys(target).forEach(key => {
      // if (options[key] === undefined) {
      //   _log.logError(`Options object for '${target.constructor.name}' has undefined value for '${key}'`);
      // }
      if (key in options && options[key] !== undefined) {
        (target as any)[key] = options[key];
      }
    });
  }

  protected customSetter<TYPE, KEY extends keyof TYPE>(object: TYPE, property: KEY, handlers: ((value: TYPE[KEY]) => void)[]) {
    let value: TYPE[KEY] = object[property];
    Object.defineProperty(object, property, {
      set(newValue: TYPE[KEY]) {
        handlers.forEach(handler => handler(newValue));
        value = newValue;
      },
      get() {
        return value;
      }
    });
  }

  public static localeDateFromUtc(sourceDate: Date| string | null): Date | null {
    if (!sourceDate) {
      return null;
    }
    return localeDateFromUTC(sourceDate);
  }

  public static localeDateToUtc(sourceDate: Date | null): string | null {
    if (!sourceDate) {
      return null;
    }
    return localeDateToUTC(sourceDate).toISOString();
  }

  public static recursiveApply(model: DtoExt, target: DtoExt): void {
    if (typeof model !== typeof target) {
      return;
    }
    const modelAsAny = model as any;
    const targetAsAny = target as any;
    for (const k of Object.keys(targetAsAny)) {
      if (targetAsAny[k] !== null) {
        if ((modelAsAny[k] instanceof DtoExt) && (targetAsAny[k] instanceof DtoExt)) {
          this.recursiveApply(modelAsAny[k], targetAsAny[k]);
        }
        continue;
      }
      if (modelAsAny[k] === null) {
        continue;
      }
      targetAsAny[k] = modelAsAny[k];
    }
  }
}
